import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip,
    IconButton,
    Typography,
    Paper,
    useTheme,
} from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";
import ResponsiveBox from "../../../components/form/ResponsiveScrollBox";
import CustomTableContainer from "../../../components/table/CustomTableContainer";
import SkeletonTableLoader from "../../../components/table/SkeletonTableLoader";
import { tokens } from "../../../theme/theme";
import dayjs from "dayjs";

export default function ConfirmationOrderItems({
    rowsConfirmedOrdersDespacth = [],
    loading = false,
    handleOn_OrderItemsCellClick,
}) {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const columnsConfirmedOrdersDespacth = [
        { field: "edit", headerName: "" },
        { field: "SIConfirmationOrderNo", headerName: "CONFIRMATION NO" },
        { field: "ShipToCustomer", headerName: "SHIP TO PARTY" },
        { field: "ShipToArea", headerName: "SHIP TO AREA" },
        { field: "ShipToCity", headerName: "SHIP TO CITY" },
        { field: "ShipToState", headerName: "SHIP TO STATE" },
        { field: "SIVariety", headerName: "QUALITY" },
        { field: "SIGSM", headerName: "GSM", align: "right" },
        { field: "SIWidth", headerName: "WIDTH" , align: "right" },
        { field: "SILength", headerName: "LENGTH" , align: "right" },
        { field: "Unit", headerName: "UNIT" },
        { field: "SIColor", headerName: "COLOR" },
        { field: "SIUnit", headerName: "UOM" },
        { field: "SINoOfSheets", headerName: "NO OF SHEETS" , align: "right" },
        { field: "SIRequested_Qty", headerName: "REQUEST QTY" , align: "right" },
        { field: "SIConfirmed_Qty", headerName: "CONFIRMATION QTY" , align: "right" },
        { field: "SIAvailableStockQty", headerName: "AVAILABLE STOCK QTY" , align: "right" },
        { field: "SIPlanned_Qty", headerName: "PLANNED QTY" , align: "right" },
        { field: "SIPending_Qty", headerName: "UN PLANNED QTY" , align: "right" },
        { field: "SIOrderType", headerName: "ORDER TYPE" },
        { field: "SIRemarks", headerName: "REMARKS" },
        { field: "SOrderConfirmationId", headerName: "ORDER CONFIRMATION ID" , align: "right" },
        { field: "SProductID", headerName: "PRODUCT ID" , align: "right" },
        { field: "SINoOfReels", headerName: "REEL COUNT" , align: "right" },
        { field: "BundleCount", headerName: "BUNDLE COUNT" , align: "right" },
        { field: "ReelBundleCount", headerName: "REEL/BUNDLE" , align: "right" },
    ];
    return (
        <ResponsiveBox
            customMaxHeight={{
                xs: "72vh",
                sm: "72vh",
                md: "74vh",
                lg: "74vh",
                xl: "82vh",
            }}
        >
            <Typography variant="h6" fontWeight='bold' mb={2}>
                Confirmed Orders Despatch
            </Typography>

            <CustomTableContainer colors={colors}>
                <TableContainer >
                    {/* component={Paper} */}
                    {loading ? (
                        <SkeletonTableLoader rows={5} columns={11} />
                    ) : (
                        <Table size="small" stickyHeader>
                            {/* Table Head */}
                            <TableHead>
                                <TableRow>
                                    {columnsConfirmedOrdersDespacth.map((col) => (
                                        <TableCell key={col.field}>{col.headerName}</TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>

                            {/* Table Body */}
                            <TableBody>
                                {rowsConfirmedOrdersDespacth.length > 0 ? (
                                    rowsConfirmedOrdersDespacth.map((row, idx) => (
                                        <TableRow key={idx} hover>
                                            {columnsConfirmedOrdersDespacth.map((col) => (
                                                <TableCell
                                                    key={col.field}
                                                    sx={{
                                                        fontSize: "0.8rem",
                                                        padding: "6px 12px",
                                                        borderRight: "1px solid #f0f0f0",
                                                          textAlign: col.align ?? "left",
                                                    }}
                                                >
                                                    {col.field === "edit" ? (
                                                        <Tooltip title="Edit">
                                                            <IconButton
                                                                size="small"
                                                                onClick={() =>
                                                                    handleOn_OrderItemsCellClick(row)
                                                                }
                                                            >
                                                                <EditIcon fontSize="small" />
                                                            </IconButton>
                                                        </Tooltip>
                                                    ) : (
                                                        row[col.field] ?? "-"
                                                    )}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell
                                            colSpan={columnsConfirmedOrdersDespacth.length}
                                            align="center"
                                        >
                                            No records found
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>

                 
                        </Table>
                    )}
                </TableContainer>
            </CustomTableContainer>
        </ResponsiveBox>
    );
}
